// extracted by mini-css-extract-plugin
module.exports = {"mobilePageHeading":"MobilePageHeading_mobilePageHeading__4f3iO"};